import React from 'react';
import { useSessionExpiry } from '../../hooks/useSessionExpiry';

const SessionExpiryModal: React.FC = () => {
  const { isSessionExpired, handleSessionExpired } = useSessionExpiry();

  if (!isSessionExpired) {
    return null;
  }

  return (
    <div className="modal-overlay" style={{ position: 'fixed', zIndex: 9999 }}>
      <div className="modal-content">
        <h2 className="modal-title">Session Expired</h2>
        <p className="modal-message">
          For security reasons, you have been logged out due to inactivity.
        </p>
        <div className="modal-actions">
          <button onClick={handleSessionExpired} className="modal-btn-cancel">
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiryModal;
